var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw",
    clipPath: "url(#clip0_13558_214066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8337 2.66509V6.66509M15.8337 6.66509H11.8337M15.8337 6.66509L12.7403 3.75842C12.0238 3.04157 11.1374 2.51789 10.1638 2.23627C9.19016 1.95465 8.16106 1.92426 7.17252 2.14793C6.18397 2.3716 5.26819 2.84205 4.51064 3.51537C3.75308 4.18869 3.17844 5.04295 2.84033 5.99842M1.16699 13.3318V9.33176M1.16699 9.33176H5.16699M1.16699 9.33176L4.26033 12.2384C4.97682 12.9553 5.86324 13.479 6.83687 13.7606C7.81049 14.0422 8.83959 14.0726 9.82813 13.8489C10.8167 13.6252 11.7325 13.1548 12.49 12.4815C13.2476 11.8082 13.8222 10.9539 14.1603 9.99842",
    stroke: "#0C66E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13558_214066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSelect);
export default __webpack_public_path__ + "static/media/refreshSelect.ef95b13046b7a4190c88ed65ad0b5a3a.svg";
export { ForwardRef as ReactComponent };